import pickBy from 'lodash/pickBy'
import { CMSProduct, SearchProduct } from '@/common/types'
import { Announcement, Notification, StandardAnnouncement } from '@/common/types/announcements'
import { SYSTEM_ERROR } from '../constants'

export const countRemainingTimeForShipping = () => {
  const date = new Date()
  const currentTime = date.getTime()
  const closeTime = new Date(date.toDateString() + ' 15:00:00 GMT+9').getTime()

  let milliseconds

  if (currentTime >= closeTime) {
    milliseconds = closeTime - currentTime + 86400 * 1000
  } else {
    milliseconds = closeTime - currentTime
  }

  const hours = Math.floor(milliseconds / 3600 / 1000)
  const minutes = Math.floor((milliseconds - hours * 3600 * 1000) / (1000 * 60))

  return hours + ' 時間 ' + minutes + ' 分以内'
}

export const formatOneDecimal = (inputPrice?: string | number) => {
  if (!inputPrice) return inputPrice
  const matchedDecimal = inputPrice.toString().match(/^-?\d+(?:\.\d{0,1})?/)
  const decimalVal = matchedDecimal ? matchedDecimal[0] : '0'
  return decimalVal.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
}

export const formatSliceYear = (inputDate?: string) => {
  if (!inputDate) return inputDate
  return inputDate.substring(5)
}

export const getSizeInputQuery = (sizeInput: { id: number, quantity: number }[]) => {
  return sizeInput.map(item => `${item.id}-${item.quantity}`).join(',')
}

export const sizeInputError = (name: string, quantity: number, unit: string) => `${name}サイズは${quantity.toLocaleString()}${unit}以下まで購入可能です`

export const formatISODate = (date: Date): string => {
  return date.toISOString().split('T')[0]
}

export const format2DigitsNumber = (number: number): string => {
  return number.toLocaleString('en-US',
    { minimumIntegerDigits: 2, useGrouping: false }
  )
}

export const cmsProductToSearchProduct = (products: readonly CMSProduct[]): SearchProduct[] => {
  return products.map(
    product => ({
      ...product,
      description: product.description || '',
      skuDetails: product.skuDetailsNonSearchPage.map(sku => ({
        ...sku,
        skuImage: sku.skuImage || ''
      })),
      wearingImage: ''
    })
  )
}

type SearchQueryData = {
  categoryId?: string | number
  industryIds?: string[] | number[]
  facet?: {
    name: string
    value: string
  }
  page?: number
  sortOrder?: string
}

export const getSearchPageQueryObject = (data: SearchQueryData) => {
  const {
    categoryId,
    industryIds,
    facet,
    page,
    sortOrder
  } = data
  const orderedQueryObj: Record<string, string> = {
    sortorder: sortOrder || '',
    page: page?.toString() || '',
    category: categoryId?.toString() || '',
    industries: industryIds?.join(',') || ''
  }
  if (facet) {
    orderedQueryObj[`f_${facet.name}`] = facet.value
  }
  return pickBy(orderedQueryObj, value => !!value)
}
export const getSearchPageQueryString = (data: SearchQueryData) => {
  return new URLSearchParams(getSearchPageQueryObject(data)).toString()
}

export const mappingAnnouncementsData = (
  announcements: Array<Announcement>
): StandardAnnouncement[] => {
  return announcements.map((announcement: Announcement) => ({
    id: announcement.id,
    announcementType: announcement.announcementType,
    content: announcement.content,
    url: announcement.url,
    displayMethod: announcement.displayMethod,
    publishDate: announcement.publishDate
  }))
}

export const mappingNotificationsData = (
  notifications: Notification[]
): StandardAnnouncement[] => {
  return notifications.map((notification: Notification) => ({
    id: notification.id,
    announcementType: notification.style,
    content: notification.content,
    url: notification.url,
    displayMethod: notification.displayMethod
  }))
}

export const limitMaxQuantityInputError = (colorPatternName: string, remainingQuantity: number) => {
  return remainingQuantity ? `${colorPatternName}の翌日出荷の受付分が残${remainingQuantity}枚となっております。` : `本日受付分について、${colorPatternName}の翌営業日に出荷できる数量の上限に達しました。`
}

export const handleExpireSessionError = () => {
  let alertCount = 0
  return () => {
    if (alertCount % 3 === 0) {
      alert(SYSTEM_ERROR[422])
    }
    alertCount++
  }
}
export const getImageSrcset = (src: string, variantName: string) => {
  return `${src}/${variantName}_1x 1x, ${src}/${variantName}_2x 2x`
}
